import { ExternalConnection, TaskCalendarOverride } from '@griply/types';
import {
  getTaskCalendarOverrideWrites,
  GetTaskCalendarSyncCandidatesOptions,
  LinkedItemGoal,
  TaskCalendarOverrideWrite,
} from '@griply/utils';
import { useCallback } from 'react';

export type UseSetTaskCalendarOverrideOptions = {
  connections: ExternalConnection[];
  goals: LinkedItemGoal[];
  mutate: (write: TaskCalendarOverrideWrite) => void;
};

export const useSetTaskCalendarOverride = ({
  connections,
  goals,
  mutate,
}: UseSetTaskCalendarOverrideOptions) =>
  useCallback(
    (
      task: GetTaskCalendarSyncCandidatesOptions['task'],
      patch: Partial<TaskCalendarOverride>,
    ) =>
      getTaskCalendarOverrideWrites({
        task,
        connections,
        goals,
        patch,
      }).forEach((write) => mutate(write)),
    [mutate, connections, goals],
  );
